// @flow
import type { Action } from './store.type';

export const GET_STOP_WORDS_REQUEST = 'GET_STOP_WORDS_REQUEST';
type GET_STOP_WORDS_REQUEST_TYPE = 'GET_STOP_WORDS_REQUEST';

export const GET_STOP_WORDS_SUCCESS = 'GET_STOP_WORDS_SUCCESS';
type GET_STOP_WORDS_SUCCESS_TYPE = 'GET_STOP_WORDS_SUCCESS';

export const GET_STOP_WORDS_FAILURE = 'GET_STOP_WORDS_FAILURE';
type GET_STOP_WORDS_FAILURE_TYPE = 'GET_STOP_WORDS_FAILURE';

export const UPDATE_STOP_WORDS_REQUEST = 'UPDATE_STOP_WORDS_REQUEST';
type UPDATE_STOP_WORDS_REQUEST_TYPE = 'UPDATE_STOP_WORDS_REQUEST';

export const UPDATE_STOP_WORDS_SUCCESS = 'UPDATE_STOP_WORDS_SUCCESS';
type UPDATE_STOP_WORDS_SUCCESS_TYPE = 'UPDATE_STOP_WORDS_SUCCESS';

export const UPDATE_STOP_WORDS_FAILURE = 'UPDATE_STOP_WORDS_FAILURE';
type UPDATE_STOP_WORDS_FAILURE_TYPE = 'UPDATE_STOP_WORDS_FAILURE';

type StopWordsSuccess = {
  data: Array<string>,
  total: number
};

type StopWordsFailure = {
  error: any
};

type GetStopWordsRequestAction = Action<GET_STOP_WORDS_REQUEST_TYPE, null>;

type GetStopWordsSuccessAction = Action<GET_STOP_WORDS_SUCCESS_TYPE, StopWordsSuccess>;

type GetStopWordsFailureAction = Action<GET_STOP_WORDS_FAILURE_TYPE, StopWordsFailure>;

type UpdateStopWordsRequestAction = Action<UPDATE_STOP_WORDS_REQUEST_TYPE, null>;

type UpdateStopWordsSuccessAction = Action<UPDATE_STOP_WORDS_SUCCESS_TYPE, StopWordsSuccess>;

type UpdateStopWordsFailureAction = Action<UPDATE_STOP_WORDS_FAILURE_TYPE, StopWordsFailure>;

// Vefify csv file before importing
export const VERIFY_CONTENT_BEFORE_IMPORT_STOP_WORDS_REQUEST =
  'VERIFY_CONTENT_BEFORE_IMPORT_STOP_WORDS_REQUEST';
type VERIFY_CONTENT_BEFORE_IMPORT_STOP_WORDS_REQUEST_TYPE =
  'VERIFY_CONTENT_BEFORE_IMPORT_STOP_WORDS_REQUEST';

export const VERIFY_CONTENT_BEFORE_IMPORT_STOP_WORDS_SUCCESS =
  'VERIFY_CONTENT_BEFORE_IMPORT_STOP_WORDS_SUCCESS';
type VERIFY_CONTENT_BEFORE_IMPORT_STOP_WORDS_SUCCESS_TYPE =
  'VERIFY_CONTENT_BEFORE_IMPORT_STOP_WORDS_SUCCESS';

export const VERIFY_CONTENT_BEFORE_IMPORT_STOP_WORDS_FAILURE =
  'VERIFY_CONTENT_BEFORE_IMPORT_STOP_WORDS_FAILURE';
type VERIFY_CONTENT_BEFORE_IMPORT_STOP_WORDS_FAILURE_TYPE =
  'VERIFY_CONTENT_BEFORE_IMPORT_STOP_WORDS_FAILURE';

type VerifyContentBeforeImportStopWordsRequestAction = Action<
  VERIFY_CONTENT_BEFORE_IMPORT_STOP_WORDS_REQUEST_TYPE,
  null
>;

type VerifyContentBeforeImportStopWordsSuccessAction = Action<
  VERIFY_CONTENT_BEFORE_IMPORT_STOP_WORDS_SUCCESS_TYPE,
  VerifyContentBeforeImportStopWordsSuccess
>;

type VerifyContentBeforeImportStopWordsFailureAction = Action<
  VERIFY_CONTENT_BEFORE_IMPORT_STOP_WORDS_FAILURE_TYPE,
  VerifyContentBeforeImportStopWordsFailure
>;

// Import file
export const IMPORT_FILE_STOP_WORDS_REQUEST = 'IMPORT_FILE_STOP_WORDS_REQUEST';
type IMPORT_FILE_STOP_WORDS_REQUEST_TYPE = 'IMPORT_FILE_STOP_WORDS_REQUEST';

export const IMPORT_FILE_STOP_WORDS_SUCCESS = 'IMPORT_FILE_STOP_WORDS_SUCCESS';
type IMPORT_FILE_STOP_WORDS_SUCCESS_TYPE = 'IMPORT_FILE_STOP_WORDS_SUCCESS';

export const IMPORT_FILE_STOP_WORDS_FAILURE = 'IMPORT_FILE_STOP_WORDS_FAILURE';
type IMPORT_FILE_STOP_WORDS_FAILURE_TYPE = 'IMPORT_FILE_STOP_WORDS_FAILURE';

type ImportFileStopWordsRequestAction = Action<IMPORT_FILE_STOP_WORDS_REQUEST_TYPE, null>;

type ImportFileStopWordsSuccessAction = Action<
  IMPORT_FILE_STOP_WORDS_SUCCESS_TYPE,
  ImportFileStopWordsSuccess
>;

type ImportFileStopWordsFailureAction = Action<
  IMPORT_FILE_STOP_WORDS_FAILURE_TYPE,
  ImportFileStopWordsFailure
>;

// Export file
export const EXPORT_FILE_STOP_WORDS_REQUEST = 'EXPORT_FILE_STOP_WORDS_REQUEST';
type EXPORT_FILE_STOP_WORDS_REQUEST_TYPE = 'EXPORT_FILE_STOP_WORDS_REQUEST';

export const EXPORT_FILE_STOP_WORDS_SUCCESS = 'EXPORT_FILE_STOP_WORDS_SUCCESS';
type EXPORT_FILE_STOP_WORDS_SUCCESS_TYPE = 'EXPORT_FILE_STOP_WORDS_SUCCESS';

export const EXPORT_FILE_STOP_WORDS_FAILURE = 'EXPORT_FILE_STOP_WORDS_FAILURE';
type EXPORT_FILE_STOP_WORDS_FAILURE_TYPE = 'EXPORT_FILE_STOP_WORDS_FAILURE';

type ExportFileStopWordsRequestAction = Action<EXPORT_FILE_STOP_WORDS_REQUEST_TYPE, null>;

type ExportFileStopWordsSuccessAction = Action<
  EXPORT_FILE_STOP_WORDS_SUCCESS_TYPE,
  ExportFileStopWordsSuccess
>;

type ExportFileStopWordsFailureAction = Action<
  EXPORT_FILE_STOP_WORDS_FAILURE_TYPE,
  ExportFileStopWordsFailure
>;

export type StopWordsAction =
  | GetStopWordsRequestAction
  | GetStopWordsSuccessAction
  | GetStopWordsFailureAction
  | UpdateStopWordsRequestAction
  | UpdateStopWordsSuccessAction
  | UpdateStopWordsFailureAction
  | VerifyContentBeforeImportStopWordsRequestAction
  | VerifyContentBeforeImportStopWordsSuccessAction
  | VerifyContentBeforeImportStopWordsFailureAction
  | ImportFileStopWordsRequestAction
  | ImportFileStopWordsSuccessAction
  | ImportFileStopWordsFailureAction
  | ExportFileStopWordsRequestAction
  | ExportFileStopWordsSuccessAction
  | ExportFileStopWordsFailureAction;

export type StopWordsState = {
  loadingStopWords: boolean,
  success: boolean,
  error: any,
  stopWords: Array<string>,
  total: number,
  // Verify file content
  verifying: boolean,
  fileContentErrorCode: string,
  totalRecord: number,

  // Import file content
  importing: boolean,
  totalImportedRecords: number
};
